// core/routes/RuleChangeRoute.tsx  (or wherever these route files live)
import { Route } from 'react-router-dom';
import React, { Suspense } from 'react';

import routeName from 'core/common/routeName';
import PrivateRoute from 'core/utils/PrivateRoute';
import PrivateRouteConst from 'core/common/privateRouteConstant';
import Loading from 'components/loading/loading';
import ConfigReportView from 'pages/reports/configReport/ConfigReportView';

const ConfigReportChangeRoute = (
  <Route path={routeName.configReportChange}>
    <Route
      path="create"
      element={
        <PrivateRoute name={[PrivateRouteConst.CREATE_REPORT_CONFIG]}>
          <Suspense fallback={<Loading />}>
            <ConfigReportView pageType="Create" />
          </Suspense>
        </PrivateRoute>
      }
    />
    <Route
      path="edit/:id"
      element={
        <PrivateRoute
          name={[
            PrivateRouteConst.REPORT_CONFIG_EDIT,
            PrivateRouteConst.SELF_REPORT_CONFIG_EDIT,
          ]}
        >
          <Suspense fallback={<Loading />}>
            <ConfigReportView pageType="Edit" />
          </Suspense>
        </PrivateRoute>
      }
    />
    <Route
      path="show/:id"
      element={
        <PrivateRoute
          name={[
            PrivateRouteConst.REPORT_CONFIG_VIEW,
            PrivateRouteConst.SELF_REPORT_CONFIG_VIEW,
          ]}
        >
          <Suspense fallback={<Loading />}>
            <ConfigReportView pageType="Show" />
          </Suspense>
        </PrivateRoute>
      }
    />
  </Route>
);

export default ConfigReportChangeRoute;
